export default "__VITE_ASSET__DIoLS8iH__"